module.exports = __webpack_public_path__ + "static/media/enquiry.1f03dc3d.svg";